export enum ProfileRoutes {
    DealMainPage = 'DealMainPage',
    DealAdminPage = 'DealAdminPage',
    RfpPage = 'RfpPage',
    ConsultAIPage = 'ConsultAIPage',
    AdminPanelPage = 'AdminPanelPage',
    AidaPage = 'AidaPage',
}
